module.exports = __webpack_public_path__ + "static/media/filters.835127d3.svg";